import React, { Component, ErrorInfo } from 'react';
import * as Sentry from '@sentry/react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class PageErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (import.meta.env.VITE_NODE_ENV === 'production') {
      Sentry.captureException(error, {
        extra: { componentStack: errorInfo.componentStack }
      });
    }
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      /* eslint-disable no-restricted-syntax -- Error boundary must use inline styles since theme context is unavailable */
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
            padding: '40px 20px',
            textAlign: 'center',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
        >
          <h2
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              margin: '0 0 8px',
              color: '#111827'
            }}
          >
            This page couldn&apos;t load
          </h2>
          <p
            style={{ fontSize: '16px', color: '#6b7280', marginBottom: '20px' }}
          >
            Something went wrong while loading this page. You can try again or
            navigate to a different page.
          </p>
          <button
            onClick={this.handleReset}
            type="button"
            style={{
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 500,
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              backgroundColor: '#fff',
              color: '#374151',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    /* eslint-enable no-restricted-syntax */
    return this.props.children;
  }
}

export default PageErrorBoundary;
